import React from 'react';
import { useIntl } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';
import { ProfileLink } from '@confluence/profile/entry-points/ProfileLinkComponent.ts';

import type { ChangeHistoryAuthor } from '../changeHistoryMacroTypes.ts';
import { getAuthorAccountId, getAuthorName } from '../changeHistoryMacroUtils.ts';

export type VersionAuthorProps = {
	author: ChangeHistoryAuthor | null | undefined;
	isCurrent: boolean;
};

export const VersionAuthor = ({ author, isCurrent }: VersionAuthorProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const authorName = getAuthorName(author, formatMessage);
	const accountId = getAuthorAccountId(author);

	const content = accountId ? (
		<ProfileCardWrapper userId={accountId} fullName={authorName} position="bottom-start">
			<ProfileLink
				userId={accountId}
				fullName={authorName}
				behavior="link"
				isUnderlinedByDefault={false}
			/>
		</ProfileCardWrapper>
	) : (
		authorName
	);

	return isCurrent ? <Text as="strong">{content}</Text> : <Text>{content}</Text>;
};
